import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchMods = async (params) => {
  const { data } = await api.get("/mods", { params });
  return data;
};

export const fetchStats = async () => {
  const { data } = await api.get("/stats");
  return data;
};

export const fetchFilters = async () => {
  const { data } = await api.get("/filters");
  return data;
};

export const fetchGzdoom = async () => {
  const { data } = await api.get("/gzdoom/latest");
  return data;
};

export const fetchFreedoom = async () => {
  const { data } = await api.get("/freedoom/latest");
  return data;
};

export const registerDownload = async (id) => {
  const { data } = await api.post(`/mods/${id}/download`);
  return data;
};

export const formatDownloads = (n) => {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1) + "K";
  return String(n);
};

export const PORT_COLORS = {
  GZDoom: { bg: "rgba(6,182,212,0.15)", border: "#06b6d4", text: "#22d3ee" },
  Boom: { bg: "rgba(245,158,11,0.15)", border: "#f59e0b", text: "#fbbf24" },
  Vanilla: { bg: "rgba(239,68,68,0.15)", border: "#ef4444", text: "#f87171" },
  Zandronum: { bg: "rgba(132,204,22,0.15)", border: "#84cc16", text: "#a3e635" },
  Eternity: { bg: "rgba(168,85,247,0.15)", border: "#a855f7", text: "#c084fc" },
};

export const portStyle = (port) =>
  PORT_COLORS[port] || {
    bg: "rgba(156,163,175,0.15)",
    border: "#9ca3af",
    text: "#d1d5db",
  };
